<span [class]="statusClass()">{{ statusText() }}</span>
